<template>
	<store-module-injector>
		<loadPlanningListMain />
	</store-module-injector>
</template>
<script>
import loadPlanningListMain from './loadPlanningListMain.vue';
import StoreModuleInjector from './StoreModuleInjector.vue';
export default { components: { StoreModuleInjector, loadPlanningListMain }, };
</script>
